import { AxiosInstance } from 'axios';
import i18n from 'i18next';

/**
 * Aggiunge alle richieste la lingua impostata nel client
 */
export function languageInterceptor(axios: AxiosInstance) {
  axios.interceptors.request.use(config => {
    config.headers['x-language'] = i18n.language;
    return config;
  });
}
